module.exports = __webpack_public_path__ + "img/check-circle-red.0063cb2d.png";